export default __webpack_public_path__ + "static/media/rewardsIllustration.9a72326f.svg";